import React, { createContext, useState, useCallback } from "react";
import { useLazyQuery, useQuery } from "@apollo/client";
import { GET_CASES, GET_COURT_CATEGORIES, LATEST_CASES } from "schema/Case";
// import notify from 'utils/toast';
import PropTypes from "prop-types";

export const CaseContext = createContext();

export default function CaseContextProvider({ children }) {
  const [
    getAllCases,
    { loading: allCasesLoading, data: allCases, fetchMore },
  ] = useLazyQuery(GET_CASES);
  const [getLatestCases, { data: latestCases }] = useLazyQuery(LATEST_CASES);
  const [allTheCases, setAllTheCases] = useState(null);
  const [allLatestCases, setAllLatestCases] = useState(null);

  const { data: court_categories } = useQuery(GET_COURT_CATEGORIES, {
    variables: { region: "ng", type: "court_categories" },
  });

  const getCases = useCallback(() => {
    getAllCases({
      variables: {
        region: "ng",
        type: "cases",
        options: {
          take: 10,
          skip: 0,
          order: {
            key: "case_id",
            value: -1,
          },
        },
      },
    });
  }, []);

  const getAllLatestCases = useCallback(() => {
    getLatestCases({
      variables: {},
    });
  }, []);

  React.useEffect(() => {
    if (allCases) {
      if (allCases.error) {
        console.log(allCases.error);
      } else {
        setAllTheCases(allCases);
      }
    }
  }, [allCases]);

  React.useEffect(() => {
    if (latestCases) {
      if (latestCases.error) {
        console.log(latestCases.error);
      } else {
        setAllLatestCases(latestCases);
      }
    }
  }, [latestCases]);

  return (
    <CaseContext.Provider
      value={{
        court_categories,
        getCases,
        allCasesLoading,
        allCases,
        fetchMore,
        allTheCases,
        setAllTheCases,
        allLatestCases,
        getAllLatestCases,
      }}
    >
      {children}
    </CaseContext.Provider>
  );
}

CaseContext.propTypes = {
  children: PropTypes.node.isRequired,
};
